module.exports = __webpack_public_path__ + "static/media/wizualizacja-38.5f5b32d3.png";